$(document).ready(function() {
    var totalQtyReceived = 0;
    var totalQtyDispensed = 0;
    var total = 0;
    var lastProcessedDrugName = null;
    var stopUpdatingTotal = false;

    $.ajax({
        url: "https://dev.redapplepharmacy.com/jotform/fetch.php",  
        method: "POST",
        success: function(response) {
            var data = JSON.parse(response);
            var table = document.getElementById("datatbl");                          
            var tableBody = document.getElementById("tb");
            
            tableBody.innerHTML = "";
            data.forEach(function(item) {   
                var row = document.createElement("tr");
                row.innerHTML = `
                    <td style="border:1px solid black;">${item["drug_name"]}</td>
                    <td style="border:1px solid black;">${item["drug_id"]}</td>
                    <td style="border:1px solid black;">${item["ndc"]}</td>
                    <td style="border:1px solid black;">${item["strength"]}</td>
                    <td style="border:1px solid black;">${item.pkg_size}</td>
                    <td style="border:1px solid black;">${item.dosage_form}</td>
                    <td style="border:1px solid black;">${item.manufacturer}</td>
                    <td style="border:1px solid black;">${item.vendor}</td>
                    <td style="border:1px solid black;"><a href="#" data-myid="${item.id}" class="hrv" style="color:orange;">View</a></td>
                `;
                tableBody.appendChild(row);
            });

            var tfoot = document.createElement("tfoot");
            tfoot.id = "tfoo";
            tfoot.style.border = "1px solid black";
            tfoot.innerHTML = `
                <tr>
                     <td  style="text-align:right;" class="updates">Drug ID:</td>
                    <td  style="text-align:right;" class="update">Drug Name:</td>
                   
                </tr>
            `;
            table.appendChild(tfoot);
            
            // Initialize the DataTable
    
            let tables = new DataTable('#datatbl');
          
        }
    });

    $(document).on("click", ".hrv", function(e) {
          function updateDrugInFooter(drugName,items) 
             {
                var footerDrugCell = document.querySelector(".update");
                footerDrugCell.innerHTML = `Drug Name: ${drugName}(${items})`;
            }
            function updateDrugIdInFooter(drugid) 
             {
                var footerDrugCell = document.querySelector(".updates");
                footerDrugCell.innerHTML = `Drug ID: ${drugid}`;
            }
        var ids = $(this).data("myid");
        var row = $(this).closest("tr"); 
        e.preventDefault();
        
        var accordionRow = row.next(".accordion-row");

        if (accordionRow.length > 0) {
            accordionRow.remove(); 
        } else {
            $(".accordion-row").remove();
            
            // Fetch and display the new accordion content
            $.ajax({
                url: "https://dev.redapplepharmacy.com/jotform/fetches.php",  
                method: "POST",
                data: { ids: ids },
                success: function(response) {
                    var accordionHTML = '';
                    var resp = JSON.parse(response);

                    resp.forEach(function(item, index) {
                        if (item.inv === "RECEIVING") {
                            if (lastProcessedDrugName && lastProcessedDrugName !== item.drug_name) {
                                 totalQtyReceived = 0;
                              
                            } 
                            else if (lastProcessedDrugName === item.drug_name) {
                                totalQtyReceived = 0;
                            }

                            var qtyReceived = parseFloat(item.qty_received) || 0;
                            totalQtyReceived += qtyReceived;
                          
                            total = totalQtyReceived  + (parseFloat(item.physical_count) || 0);
                             
                            lastProcessedDrugName = item.drug_name;
                            updateDrugInFooter(item.drug_name,item.inv);
                            updateDrugIdInFooter(item.drug_id);
                        }

                        if (item.inv === "DISPENSING") {
                          
                            if (lastProcessedDrugName === item.drug_name) {
                              
                                stopUpdatingTotal = false;
                                totalQtyDispensed = 0;
                            } 
                            else if(lastProcessedDrugName !== item.drug_name){
                                // alert("First select its corresponding drug(Receving) to get BOH")
                              total=0;
                              totalQtyDispensed=0;
                              stopUpdatingTotal = true;
                            }
                          
                            if (!stopUpdatingTotal) {
                                var qtyDispensed = parseFloat(item.qty_dispensed) || 0;
                                totalQtyDispensed += qtyDispensed;
                                total = totalQtyReceived - totalQtyDispensed + (parseFloat(item.physical_count) || 0);
                              
                            }
                          updateDrugInFooter(item.drug_name,item.inv);
                          updateDrugIdInFooter(item.drug_id);
                        }
                        if (item.inv === "MONTHLY/RANDOM INV") {
                                total = parseFloat(item.physical_count) || 0;
                                updateDrugInFooter(item.drug_name,item.inv);
                                updateDrugIdInFooter(item.drug_id);
                        }
                        var accordionTable = '';

                        if (item.inv === "RECEIVING") {
                            accordionTable = `
                                <table style="width:100%; border:1px solid black;" class="accord-table">
                                    <tr class="accord"><th>Drug ID</th><th>Drug Name</th><th>CSOS</th><th>PO</th><th>Date Received</th><th>Quantity Received</th><th>Received By</th><th>Physical Count</th><th>Balance On Hand(BOH)</th></tr>
                                    <tr style="text-align:center";>
                                        <td>${item.drug_id}</td>
                                        <td>${item.drug_name}</td>
                                        <td>${item.csos}</td>
                                        <td>${item.po}</td>
                                        <td>${item.date_received}</td>
                                        <td>${item.qty_received}</td>
                                        <td>${item.received_by || 'N/A'}</td>
                                        <td>${item.physical_count || 'N/A'}</td>
                                        <td class="boh">${total}</td>
                                    </tr>
                                </table>
                            `;
                        }

                        if (item.inv === "DISPENSING") {
                            accordionTable = `
                                <table style="width:100%; border:1px solid black;" class="accord-table">
                                    <tr class="accord"><th>Drug ID</th><th>Drug Name</th><th>Patient Name</th><th>RX</th><th>Qty Dispensed</th><th>Date Dispensed</th><th>Dispensed By</th><th>Physical Count</th><th>Balance On Hand(BOH)</th></tr>
                                    <tr style="text-align:center";>
                                        <td>${item.drug_id}</td>
                                        <td>${item.drug_name}</td>
                                        <td>${item.patient_name}</td>
                                        <td>${item.rx}</td>
                                        <td>${item.qty_dispensed}</td>
                                        <td>${item.date_dispensed}</td>
                                        <td>${item.dispensed_by || 'N/A'}</td>
                                        <td>${item.physical_count || 'N/A'}</td>
                                        <td class="boh">${total}</td>
                                    </tr>
                                </table>
                            `;
                        }

                        if (item.inv === "MONTHLY/RANDOM INV") {
                            accordionTable = `
                                <table style="width:100%; border:1px solid black;" class="accord-table">
                                    <tr class="accord"><th>Drug ID</th><th>Drug Name</th><th>Physical Count</th><th>Date Counted</th><th>Balance On Hand(BOH)</th></tr>
                                    <tr style="text-align:center;">
                                        <td>${item.drug_id}</td>
                                        <td>${item.drug_name}</td>
                                        <td>${item.physical_count || 'N/A'}</td>
                                        <td>${item.date_counted || 'N/A'}</td>
                                        <td class="boh">${total}</td>
                                    </tr>
                                </table>
                            `;
                        }

                        accordionHTML += `
                            <tr class="accordion-row">
                                <td colspan="9">${accordionTable}</td>
                            </tr>
                        `;
                    });

                    row.after(accordionHTML);
                    // $(".boh").text(total);
                },
                error: function(error) {
                    console.error("Error loading data:", error);
                }
            });
        }
    });
});
